module.exports = __webpack_public_path__ + "img/raw5.f64f77dd.png";